import { useContext } from "react";
import { Link } from "react-router-dom";
import { contextTheme } from "../contexts/ProviderTheme";
import ButtonToCart from "./ButtonToCart";
import { URL_INFURA, cortador } from "../helpers";

export default function Product({ product, addToCart }) {

  const { theme } = useContext(contextTheme);
  const styles = {
    font: {
      color: !theme ? "#333" : "#FFF",
    },
    coin: {
      fontSize: ".7rem",
    },
    discount: {
      backgroundColor: "#f8f8f8",
      padding: "10px 15px",
      fontSize: ".7rem",
      color: "#333",
    },
  };

  return (
    <div className="item">
      <Link to={`/product/detail/${product.id}`}>
        <div>
          <img
            alt={product.title}
            src={`${URL_INFURA}${product.url_image_1}`}
          />
        </div>
        <span className="title" style={styles.font}>
          {cortador(product.title)}
        </span>
      </Link>
      <div className="score" style={styles.font}>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
        <i className="fas fa-star"></i>
      </div>
      <div className="price">
        <span className="old" style={styles.font}>
          {(product.price * 1.1).toFixed(2)}
        </span>
        &nbsp;
        <span className="actual" style={styles.font}>
          {product.price} <span style={styles.coin}>DAI/ USDT/ BUSD</span>
        </span>
      </div>

      {product.discount ? (
        <div style={styles.discount}>
          {`${product.discount}% off`} <i className="fas fa-arrow-right"></i>{" "}
          {`Wallet: ${product.minimum_amount_discount} $STORE`}
        </div>
      ) : null}

      <ButtonToCart product={product} addToCart={addToCart} />
    </div>
  );
}
